var map = {
	"./decidim/avatar-multiuser.png": 63720,
	"./decidim/brands/google.svg": 94135,
	"./decidim/cc-badge.png": 77282,
	"./decidim/decidim-logo.svg": 91050,
	"./decidim/default-avatar.svg": 94358,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 2218,
	"./decidim/icons.svg": 60249,
	"./decidim/pattern.png": 77398,
	"./decidim/placeholder-card-g.svg": 95003,
	"./decidim/placeholder-card-l.svg": 44976,
	"./decidim/placeholder.jpg": 66071,
	"./decidim/remixicon.symbol.svg": 56847,
	"./decidim/vendor/leaflet/layers-2x.png": 73458,
	"./decidim/vendor/leaflet/layers.png": 9881,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 24256,
	"./decidim/vendor/leaflet/marker-icon.png": 61663,
	"./decidim/vendor/leaflet/marker-shadow.png": 37292,
	"./decidim/vendor/social-share-button/douban.svg": 86782,
	"./decidim/vendor/social-share-button/email.svg": 74459,
	"./decidim/vendor/social-share-button/facebook.svg": 40957,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 21191,
	"./decidim/vendor/social-share-button/hacker_news.svg": 6431,
	"./decidim/vendor/social-share-button/linkedin.svg": 36195,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 91020,
	"./decidim/vendor/social-share-button/pinterest.svg": 88877,
	"./decidim/vendor/social-share-button/reddit.svg": 75741,
	"./decidim/vendor/social-share-button/telegram.svg": 36452,
	"./decidim/vendor/social-share-button/tumblr.svg": 35499,
	"./decidim/vendor/social-share-button/twitter.svg": 29434,
	"./decidim/vendor/social-share-button/vkontakte.svg": 79236,
	"./decidim/vendor/social-share-button/wechat.svg": 88031,
	"./decidim/vendor/social-share-button/whatsapp.svg": 10303,
	"./decidim/vendor/social-share-button/x.svg": 54043,
	"./decidim/vendor/social-share-button/xing.svg": 52045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39581;